import styled from '@emotion/styled';

export const ProductImageOrder = styled.img`
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 8px;
`;